import React, { useState } from 'react';
import './Contact.css';
import Map from '../home-pages/Map'
import Form from '../home-pages/Form';
import Footer from '../home-pages/Footer';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    industry: '',
    budget: '',
    message: '',
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'name':
        if (!value.trim()) error = 'Name is required.';
        break;
      case 'phone':
        if (!value.trim()) {
          error = 'Phone is required.';
        } else if (!/^\d{10}$/.test(value)) {
          error = 'Phone must be exactly 10 digits.';
        }
        break;
      case 'email':
        if (!value.trim()) {
          error = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = 'Enter a valid email address.';
        }
        break;
      case 'industry':
        if (!value) error = 'Industry is required.';
        break;
      case 'budget':
        if (!value) error = 'Budget is required.';
        break;
      case 'message':
        if (!value.trim()) error = 'Message is required.';
        break;
      case 'agree':
        if (!value) error = 'You must agree to the terms.';
        break;
      default:
        break;
    }
    return error;
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setFormData({
      ...formData,
      [name]: fieldValue,
    });

    const fieldError = validateField(name, fieldValue);
    setErrors({
      ...errors,
      [name]: fieldError,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await fetch('https://formsubmit.co/contact@sammarshya.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });
        if (response.ok) {
          setSubmitted(true);
          setFormData({
            name: '',
            phone: '',
            email: '',
            industry: '',
            budget: '',
            message: '',
            agree: false,
          });
          setErrors({});
        } else {
          alert('Failed to send message. Please try again later.');
        }
      } catch (error) {
        alert('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div>
      <div className="contact-page-section">
        <div className="contact-page-content-i">
          <div className="contact-page-text">
            <h1 className="contact-page-content-hh">Contact us</h1>
            <p>
              If there is anything you would like to talk about, please feel free to contact us. Even if you just want to say hello, we look forward to hearing from you!
            </p>
          </div>
        </div>
      </div>
      <div className="contact-us-wrapper">
        <div className="contact-us-left">
          <h1>Let's discuss your project</h1>
          <p>
            Order a free consultation – our experts will select the most effective solution
          </p>
        </div>
        <div className="contact-us-right">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <span className="validation-error">{errors.name}</span>}
            </div>
            <div className="form-row">
              <div className="form-group" style={{ flex: 1, marginRight: '10px' }}>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  className="form-input"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <span className="validation-error">{errors.phone}</span>}
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="validation-error">{errors.email}</span>}
              </div>
            </div>
            <div className="form-row">
            <div className="form-group">
  <select
    name="industry"
    className="form-input custom-select"
    value={formData.industry}
    onChange={handleChange}
  >
    <option value="" disabled>
      Industry
    </option>
    <option value="IT">Oil & Gas</option>
    <option value="Ecommerce">Ecommerce</option>
    <option value="Healthcare">Healthcare</option>
    <option value="Logistic">Logistic</option>
    <option value="Education">Education</option>
  </select>
  {errors.industry && <span className="validation-error">{errors.industry}</span>}
</div>
<div className="form-group">
  <select
    name="budget"
    className="form-input custom-select"
    value={formData.budget}
    onChange={handleChange}
  >
    <option value="" disabled>
      Expected Budget
    </option>
    <option value="&lt;10k">&lt;10k</option>
    <option value="20k-50k">20k-50k</option>
    <option value="50k-100k">50k-100k</option>
    <option value="&gt;100k">&gt;100k</option>
  </select>
  {errors.budget && <span className="validation-error">{errors.budget}</span>}
</div>
</div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Message"
                className="form-textarea"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && <span className="validation-error">{errors.message}</span>}
            </div>
            <div className="form-group checkbox-group-c">
              <input
                type="checkbox"
                id="agree"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
              />
              <p>
                <label htmlFor="agree">
                  I agree that my personal information will be processed and stored by Sammarshya.
                </label>
              </p>
              {errors.agree && <span className="validation-error">{errors.agree}</span>}
            </div>
            <button type="submit" className="form-submit-button">
              SEND MESSAGE
            </button>
            {submitted && <p className="success-text">Message sent successfully!</p>}
          </form>
        </div>
      </div>

      <Map/>
      <Form/>
      <Footer/>
    </div>
  );
}
